import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';

type ToastMessage = Parameters<MessageService['add']>[0];

const STORAGE_KEY = 'pendingToast';

/**
 * Permet d'afficher un toast APRÈS un rechargement complet de page (`window.location.reload()`).
 *
 * Un reload détruit l'app Angular → le `MessageService` (en mémoire) perd ses messages.
 * On mémorise donc le toast dans `sessionStorage` avant le reload, et on le ré-émet une fois
 * au démarrage (`flushPending`, appelé par `App` une fois `<p-toast>` monté).
 */
@Injectable({ providedIn: 'root' })
export class PendingToastService {
  private readonly messages = inject(MessageService);

  /** Mémorise un toast à afficher juste après le prochain rechargement de page. */
  queueForReload(message: ToastMessage): void {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(message));
    } catch {
      // sessionStorage indisponible (mode privé strict) : on renonce silencieusement.
    }
  }

  /** Émet le toast en attente s'il existe, puis le purge (affichage unique). */
  flushPending(): void {
    let raw: string | null = null;
    try {
      raw = sessionStorage.getItem(STORAGE_KEY);
      sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      return;
    }
    if (!raw) {
      return;
    }
    try {
      this.messages.add(JSON.parse(raw) as ToastMessage);
    } catch {
      // Payload corrompu : on ignore.
    }
  }
}
